import { Button, SizableText, SmartLink, Stack, XStack, YStack, YStackProps } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { FeaturedContentCarouselBlock } from './featured-content-carousel.block'

export const FeaturedContentCarouselItem = ({
  title,
  description,
  image,
  link,
  linkText,
  newTab,
  ...props
}: FeaturedContentCarouselBlock['items'][0] & YStackProps) => {
  return (
    <YStack gap="$2" {...props}>
      <SmartLink
        Component={YStack}
        href={link}
        gap="$3.5"
        hoverStyle={{
          opacity: 0.85,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
        focusStyle={{
          opacity: 0.8,
        }}
        target={newTab ? '_blank' : undefined}
        rel="noopener noreferrer"
      >
        <Stack overflow="hidden" aspectRatio={1} width="100%" br="$3">
          <SolitoImage
            src={image.url}
            alt={image.alt || title || 'Ad image'}
            contentFit="cover"
            fill
            sizes="(max-width: 768px) 200px, 288px"
          />
        </Stack>
        <YStack gap="$1.5" flex={1}>
          {title && (
            <SizableText
              size="$4.5"
              fow="700"
              textAlign="center"
              $gtSm={{ size: '$7.5', fow: '700' }}
              numberOfLines={2}
            >
              {title}
            </SizableText>
          )}
          {description && (
            <SizableText size="$3" color="$gray12" textAlign="center" numberOfLines={2}>
              {description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>
      {linkText && (
        <XStack mt="auto">
          <SmartLink
            Component={Button}
            href={link}
            flex={1}
            theme="black"
            size="$4"
            target={newTab ? '_blank' : undefined}
            rel="noopener noreferrer"
          >
            {linkText}
          </SmartLink>
        </XStack>
      )}
    </YStack>
  )
}
